import React from 'react';
import MobilePhotos from './MobilePhotos';

// PUBLIC mobile photo-handoff page: /m/photos/:sessionId
// Intentionally standalone — NO marketing Header/Footer Layout. This page is
// opened on a phone after scanning the QR shown on a desktop "Post a Project"
// session. The sessionId is the capability/secret (no login needed).
async function action({ params, largeProjectsEnabled }) {
  // LARGE PROJECTS FLAG: when OFF this LP photo-handoff route is unreachable ->
  // redirect home (additive guard; small-jobs routes untouched). Flag read from
  // the router context (server-only DB read in server.js / SSR-seeded runtime on
  // client); fail-closed at the source.
  if (!largeProjectsEnabled) {
    return { redirect: '/' };
  }
  return {
    title: 'Add photos — BestHand',
    description: 'Take photos on your phone and add them to your project on your computer.',
    // No <Layout> wrapper: a focused, mobile-first single-purpose screen.
    component: <MobilePhotos sessionId={params.sessionId} />,
  };
}

export default action;
